import React from "react";
import SearchSelectBox from "../SearchSelectBox";
import { EmploymentStatus, employmentStatusNaming, RegisteredPosition, registeredPositionNaming } from "../../api/typesDc";
import { useTranslation } from "react-i18next";
import AutoComplete from "../AutoComplete";

const RegisteredPositionAutoComplete = (props:any) => {
    const { selectedValues, manageSelect, isReadOnly } = props;
    const [t] = useTranslation();
    const options = [
      {
        value: RegisteredPosition.DC_RP_HEAD_COACH,
        name: t(registeredPositionNaming[RegisteredPosition.DC_RP_HEAD_COACH]),
      },
      {
        value: RegisteredPosition.RP_ACADEMY_DIRECTOR,
        name: t(registeredPositionNaming[RegisteredPosition.RP_ACADEMY_DIRECTOR]),
      },
      {
        value: RegisteredPosition.RP_ACADEMIC_TEAM_DIRECTOR,
        name: t(registeredPositionNaming[RegisteredPosition.RP_ACADEMIC_TEAM_DIRECTOR]),
      },
      {
        value: RegisteredPosition.RP_ACADEMIC_TEAM_COACH,
        name: t(registeredPositionNaming[RegisteredPosition.RP_ACADEMIC_TEAM_COACH]),
      },
      {
        value: RegisteredPosition.RP_SCHOOL_COACH,
        name: t(registeredPositionNaming[RegisteredPosition.RP_SCHOOL_COACH]),
      },
      { value: RegisteredPosition.RP_OTHER, name: t(registeredPositionNaming[RegisteredPosition.RP_OTHER]) },
    ];

    const manageRPSelect = (d:any) => {
      let tempRP = [];
      const index = selectedValues.findIndex((item:any) => item == d.value);
      if(index !== -1) {
        tempRP = selectedValues.filter((item:any) => item != d.value);
      } else {
        tempRP = [...selectedValues, d.value];
      }
      manageSelect(tempRP);
    }

    return (
        <>
            <AutoComplete 
            options={options}
            selectedValues={selectedValues}
            handleMenuClick={manageRPSelect} 
            label={t('DC_5_REGISTERED_POSITION')}
            clickReset={() => {manageSelect([])}}
            isMultiple={true}
            isReadOnly={isReadOnly}
            />
        </>
    );
}

export default RegisteredPositionAutoComplete;